var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#313131"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1170_1409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 11.6552H20.6207L20.6207 20.6207L11.6552 20.6207V22L22 22L22 11.6552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9942 11.6552C21.8124 6.29199 17.4074 2 12 2C6.47715 2 2 6.47715 2 12C2 17.4074 6.29199 21.8124 11.6552 21.9942V20.6139C7.05395 20.4329 3.37931 16.6456 3.37931 12C3.37931 7.23892 7.23892 3.37931 12 3.37931C16.6456 3.37931 20.4329 7.05395 20.6139 11.6552H21.9942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7241 15.11H10.2693L9.61248 17.0805H7.51724L11.0772 7.51724H12.9031L16.4828 17.0805H14.3875L13.7241 15.11ZM10.8013 13.514H13.1921L11.9901 9.93432L10.8013 13.514Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1170_1409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotate);
export default __webpack_public_path__ + "static/media/Annotate.8a8e1bc2fb5bc86160186dec97f5500a.svg";
export { ForwardRef as ReactComponent };